module.exports = __webpack_public_path__ + "img/dragonslair (0).5156c57d.jpg";